<template>
  <cus-dialog>
    <template v-slot:title>
      <p class="dialog-title">{{ giftsData[currentAct - 1].event_name }}</p>
    </template>
    <template v-slot:body>
      <div style="padding: 0 4px">
        <p class="dialog-note">符合活動資格，共可兌換{{ giftsData[currentAct - 1].changable_amount }}份</p>
        <div v-for="(gift, index) in giftsData[currentAct - 1].gift_info" :key="index" class="add-on-item">
          <cus-button
            color="blue"
            topIcon="dash-lg"
            buttonClass="icon"
            :disabled="gift.amount === 0"
            @click="gift.amount -= 1"
          ></cus-button>
          <div class="item-info">
            <p>{{ gift.name }}：</p>
            <p>{{ gift.amount }}</p>
          </div>
          <cus-button
            color="blue"
            topIcon="plus-lg"
            buttonClass="icon"
            @click="gift.amount += 1"
            :disabled="addBtnIsDisabled()"
          ></cus-button>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="不兌換" color="white" :width="50" @click="clickBottomBtn('不兌換')"></cus-button>
        <cus-button
          :text="'兌換 ' + currentAct + '/' + giftsData.length"
          color="blue"
          :width="50"
          @click="clickBottomBtn('兌換')"
          :disabled="exchangeBtnIsDisabled()"
        ></cus-button>
      </div>
    </template>
  </cus-dialog>
</template>
<script>
import { inject, ref } from 'vue';
import { useActions } from '@/utils/mapStore';
export default {
  name: 'redeemBonus',
  setup() {
    //接受provide值
    const name = inject('name');
    const giftsData = inject('content');
    const { cusProps } = inject('cusProps');
    const submit = inject('submit');

    //初始值
    const currentAct = ref(1);
    const isRedeemed = ref([]);

    // ＋按鈕的disable判斷
    const addBtnIsDisabled = () => {
      let sum = 0;
      giftsData.value[currentAct.value - 1].gift_info.forEach((gift) => (sum += gift.amount));
      if (sum >= giftsData.value[currentAct.value - 1].changable_amount) return true;
      else return false;
    };
    // 兌換按鈕的disable判斷
    const exchangeBtnIsDisabled = () => {
      if (addBtnIsDisabled() == true) return false;
      else return true;
    };
    // click 兌換/不兌換按鈕
    const doRedeemWelcomeGift = useActions('checkout', ['doRedeemWelcomeGift']);
    const clickBottomBtn = async (str) => {
      if (str == '兌換') {
        let pushData = giftsData.value[currentAct.value - 1].event_name + '：';
        giftsData.value[currentAct.value - 1].gift_info.forEach((gift) => {
          if (gift.amount > 0) pushData += `${gift.name}*${gift.amount} / `;
        });
        pushData = pushData.slice(0, -2);
        isRedeemed.value.push(pushData);
        await doRedeemWelcomeGift({
          event_id: giftsData.value[currentAct.value - 1].event_id,
          redeem_gifts: giftsData.value[currentAct.value - 1].gift_info,
        });
      } else {
        await doRedeemWelcomeGift({ event_id: giftsData.value[currentAct.value - 1].event_id, redeem_gifts: [] });
      }
      if (currentAct.value >= giftsData.value.length) {
        submit({ gifts: isRedeemed.value, checkoutInfo: cusProps.checkoutInfo });
      } else {
        currentAct.value += 1;
      }
    };

    return { name, giftsData, currentAct, addBtnIsDisabled, exchangeBtnIsDisabled, clickBottomBtn };
  },
};
</script>
<style lang="scss" scoped>
.dialog-title {
  text-align: center;
  font-size: 2.4rem;
  line-height: 60px;
  color: $color-blue;
}
.dialog-note {
  font-size: 16px;
  color: #6b6b6b;
  text-align: center;
}
.add-on-item {
  @include flex-between-center;
  margin: 8px 0;

  :deep(.icon) {
    width: 80px !important;
    -webkit-text-stroke: 0.5px white;
  }

  .item-info {
    width: 240px;
    display: grid;
    grid-template-columns: 65% auto;
    align-items: center;

    p:nth-of-type(1) {
      font-size: 2.4rem;
      color: $color-blue;
    }

    p:nth-of-type(2) {
      font-size: 4.2rem;
      color: $color-green;
    }
  }
}
</style>
